module.exports = __webpack_public_path__ + "static/media/moon.433dc7b7.svg";